import { useEffect } from 'react';

const KEY_CODES = {
  UP: 38,
  DOWN: 40,
  RIGHT: 39,
  LEFT: 37,
};

function useKeyPress(targetKeyCode, onPress) {
  useEffect(() => {
    function downHandler(event) {
      const { keyCode } = event;
      if (keyCode === targetKeyCode) {
        onPress(event);
      }
    }

    window.addEventListener('keydown', downHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
    };
  }, [onPress, targetKeyCode]);
}

export default function useKeyboardNavigation(nextHandler, previousHandler) {
  useKeyPress(KEY_CODES.UP, previousHandler);
  useKeyPress(KEY_CODES.LEFT, previousHandler);

  useKeyPress(KEY_CODES.DOWN, nextHandler);
  useKeyPress(KEY_CODES.RIGHT, nextHandler);
}
